import { useQueryClient } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { selectMessageTargets } from './selectMessageTargets';

export const useSelectMessageTargets = () => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  const selectMessageTarget = async (
    senderMmsi: number,
    receiverMmsi: number,
  ) => {
    try {
      const data = await selectMessageTargets(
        olSession,
        senderMmsi,
        receiverMmsi,
      );
      queryClient.setQueryData(
        ['selectMessageTarget', senderMmsi, receiverMmsi],
        data,
      );
      return data;
    } catch (error) {
      console.error('Error fetching event data:', error);
      throw error;
    }
  };

  return selectMessageTarget;
};
